import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { ReactNode } from 'react'

export interface LibraryDialogProps {
	children?: ReactNode
	open: boolean
	onClose: () => void
}

export function LibraryDialog({ children, open, onClose }: LibraryDialogProps) {
	return (
		<Dialog open={open} onClose={onClose} className="relative z-50">
			<DialogBackdrop
				transition
				className="fixed inset-0 bg-black/20 backdrop-blur-sm transition-opacity duration-200 ease-out data-closed:opacity-0"
			/>
			<div className="fixed inset-0 w-screen overflow-y-auto">
				<div className="flex min-h-full items-center justify-center">
					<DialogPanel
						transition
						className="ring ring-grey-200/50 rounded-sm shadow-md max-w-10xl w-[calc(100vw-6rem)] h-[calc(100vh-6rem)] bg-white transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0"
					>
						{children}
					</DialogPanel>
				</div>
			</div>
		</Dialog>
	)
}
